<div class="modal-header">
  <h3 class="modal-title">Attention! Vous vous apprétez à supprimer {{ this.objectDefinition }} !</h3>
</div>
<div class="modal-body">
  <p>Cette opération est irréversible. Les données seront perdues. Voulez-vous vraiment
    supprimer {{ this.objectDefinition }}?</p>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-light" data-bs-dismiss="modal" type="button">Ne pas
    supprimer
  </button>
  <button (click)="activeModal.close(true)" class="btn btn-danger" type="button">Oui, je veux supprimer</button>
</div>
